import {connect} from 'react-redux'
import moment from 'moment'

import {Details} from './details.component'
import {updateDestination} from '../planner/planner.action'
import legUtil from '../util/leg.util'
import userUtil from '../util/user.util'

import {onChangeDetailsSection, onChangeDetailsUI, activateAccommodation, activateActivity, activateTravel} from './details.action'
import {onSelectAccommodation, onUpdateAccommodationReservation, onRemoveAccommodation, onUpdateActivityReservation, onSelectActivity, onRemoveActivity, activateLeg} from '../leg/leg.action'

import deeplinksUtil from '../util/deeplinks.util'
import mixpanelUtil from '../util/mixpanel.util'

const mapStateToProps = (state) => {
    let arrival = state.getIn(['document', 'properties', 'arrivalDate'])
    let departure = state.getIn(['document', 'properties', 'departureDate'])

    return {
        leg: legUtil.getActiveLeg(state),
        lastLeg: legUtil.getLastLeg(state),
        totalDays: state.getIn(['document', 'properties', 'totalDays']) || 1,
        arrivalDate: arrival ? moment(arrival) : null,
        departureDate: departure ? moment(departure) : null,
        presence: state.getIn(['socket', 'presence']),
        originDestination: state.getIn(['document', 'properties', 'origination']),
        returnDestination: state.getIn(['document', 'properties', 'return']),
        bookingActive: state.getIn(['uiState', 'bookingActive']),
        detailSection: state.getIn(['uiState', 'detailSection']),
        detailSubSection: state.getIn(['uiState', 'detailSubSection']),
        detailSubDetail: state.getIn(['uiState', 'detailSubDetail']),
        activeAccommodation: state.getIn(['uiState', 'activeAccommodation']),
        activeAccommodationId: state.getIn(['uiState', 'activeAccommodationId']),
        activeActivityId: state.getIn(['uiState', 'activeActivityId']),
        activeActivity: state.getIn(['uiState', 'activeActivity']),
        activeTravel: state.getIn(['uiState', 'activeTravel']),
        currentUser: userUtil.getCurrentUser(state),
        tripGuid: state.getIn(['document', 'properties', 'tripGuid']),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onActivateLeg: (leg) => {
            dispatch(activateLeg(leg))
        },
        onSelectDestination: (leg, destination) => {
            dispatch(updateDestination(leg, destination))
        },
        onSelectAccommodation: (leg, accommodation, user) => {
            mixpanelUtil.send('savingAccommodation', {
                destination: leg.getIn(['destination', 'title']),
                accommodation: accommodation.get('name'),
                accommodation_id: accommodation.get('id')
            })
            dispatch(onSelectAccommodation(leg, accommodation, user))
        },
        onUpdateAccommodationReservation: (leg, accommodation) => {
            mixpanelUtil.send('accommodationReservation', {
                destination: leg.getIn(['destination', 'title']),
                accommodation: accommodation.get('name'),
                accommodation_id: accommodation.get('id')
            })
            dispatch(onUpdateAccommodationReservation(leg, accommodation))
        },
        onRemoveAccommodation: (leg, accommodation) => {
            dispatch(onRemoveAccommodation(leg, accommodation))
        },
        onChangeDetailsSection: (section) => {
            // used for presence only
            dispatch(onChangeDetailsSection(section))
        },
        onUpdateDeepLink: (leg, section, subsection, subdetail, activeObj) =>{
            let deepLinkData = {
                'leg': leg,
                'section': section,
                'subsection': subsection,
                'subdetail': subdetail,
                'activeObj': activeObj
            }

            deeplinksUtil.pushDeepLink('UISTATUS', deepLinkData)
        },
        onChangeDetailsUI: (section, subsection, subdetail) => {
            // used to set the actual UI state of the lower section
            dispatch(onChangeDetailsUI(section, subsection, subdetail))
        },
        onSelectActivity: (leg, activity, user) => {
            mixpanelUtil.send('savingActivity', {
                destination: leg.getIn(['destination', 'title']),
                activity: activity.get('name'),
                place_id: activity.get('place_id')
            })
            dispatch(onSelectActivity(leg, activity, user))
        },
        onUpdateActivityReservation: (leg, activity) => {
            mixpanelUtil.send('activityReservation', {
                destination: leg.getIn(['destination', 'title']),
                activity: activity.get('name'),
                place_id: activity.get('place_id')
            })
            dispatch(onUpdateActivityReservation(leg, activity))
        },
        onRemoveActivity: (leg, activity) => {
            dispatch(onRemoveActivity(leg, activity))
        },
        onActivateAccommodation: (accommodation) => {
            dispatch(activateAccommodation(accommodation))
        },
        onActivateActivity: (activity) => {
            dispatch(activateActivity(activity))
        },
        onActivateTravel: (travel) => {
            dispatch(activateTravel(travel))
        },
    }
}

const DetailsContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Details)

export default DetailsContainer
